let helper = {
    $modal: $('#sitewide-popup'),
    getWidth: function () {
        return Math.max(
            document.documentElement.clientWidth,
            window.innerWidth || 0
        )
    },
    getUid: function () {
        return Math.random().toString(32).substr(2, 8)
    },
    testObjectFit: function () {
        if ('objectFit' in document.documentElement.style === true) {
            const images = document.getElementsByClassName('js-image-fit')

            for (let i = 0; i < images.length; i += 1) {
                images[i].classList.add('image-fit')
            }
        }
    },
    scrollIntoView: function ($element) {
        $('html, body').animate(
            {
                scrollTop: $element.offset().top - 240,
            },
            240
        )
    },
    setBodyScrollData: function () {
        let currentPosition = $(window).scrollTop()
        $('html').data('store-scroll-top-position', currentPosition)
    },
    restoreBodyScrollData: function () {
        let storedPosition = $('html').data('store-scroll-top-position')
        if (storedPosition) {
            $('.website-content, .website-footer').removeAttr('style')
            $(window).scrollTop(storedPosition)
            $('html').removeData('store-scroll-top-position')
        }
    },
    timer: function (fn, t) {
        var timerObj = setInterval(fn, t)

        this.stop = function () {
            if (timerObj) {
                clearInterval(timerObj)
                timerObj = null
            }
            return this
        }
        // start timer using current settings (if it's not already running)
        this.start = function () {
            if (!timerObj) {
                this.stop()
                timerObj = setInterval(fn, t)
            }
            return this
        }
        // start with new or original interval, stop current interval
        this.reset = function (newT = t) {
            t = newT
            return this.stop().start()
        }
    },
    isElementInViewport: function (el, type) {
        if (typeof jQuery === 'function' && el instanceof jQuery) {
            el = el[0]
        }
        if (!el) {
            return false
        }
        let lazyLoadingBuffer = 90
        let rect = el.getBoundingClientRect()
        let rectCenter = rect.top + rect.height / 2

        switch (type) {
            // Returns true if the ideal vertical center
            // of the element is in the viewport
            case 'centerInView':
                return (
                    rectCenter >= 0 &&
                    rect.left >= 0 &&
                    rectCenter <=
                        (window.innerHeight ||
                            document.documentElement.clientHeight) &&
                    rect.right <=
                        (window.innerWidth ||
                            document.documentElement.clientWidth)
                )
            // Returns true if a part of the element is in the viewport
            // (with a buffer for the lazy loading values)
            case 'partialInView':
                return (
                    rect.top >= -(rect.height - lazyLoadingBuffer) &&
                    rect.top + lazyLoadingBuffer <=
                        (window.innerHeight ||
                            document.documentElement.clientHeight) &&
                    rect.left >= 0
                )
            // Specific case for the internal job page(job article)
            // Returns true if there is enough space(80px) under the header(hero) to display an apply button
            case 'partialPastView':
                return (
                    rect.bottom <=
                    (window.innerHeight - 65 ||
                        document.documentElement.clientHeight - 65)
                )
            // Returns true if the entire element is in the viewport
            default:
                return (
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <=
                        (window.innerHeight ||
                            document.documentElement
                                .clientHeight) /* or $(window).height() */ &&
                    rect.right <=
                        (window.innerWidth ||
                            document.documentElement.clientWidth)
                ) /* or $(window).width() */
        }
    },
    handleGesture: function (targetArea, attach, callBack) {
        let touchstartX = 0
        let touchstartY = 0
        let touchendX = 0
        let touchendY = 0
        let minDiff = 30

        const $gestureZone = $(targetArea)

        let handleTouchStart = function (event) {
            touchstartX = event.changedTouches[0].screenX
            touchstartY = event.changedTouches[0].screenY
        }

        let handleTouchEnd = function (event) {
            touchendX = event.changedTouches[0].screenX
            touchendY = event.changedTouches[0].screenY
            handleGesture()
        }

        if (attach) {
            $gestureZone.on('touchstart', handleTouchStart)
            $gestureZone.on('touchend', handleTouchEnd)
        } else {
            $gestureZone.off('touchstart')
            $gestureZone.off('touchend')
        }

        function handleGesture() {
            let result = []
            if (touchendX + minDiff < touchstartX) {
                result.push('left')
            }

            if (touchendX - minDiff > touchstartX) {
                result.push('right')
            }

            if (touchendY < touchstartY) {
                result.push('up')
            }

            if (touchendY > touchstartY) {
                result.push('down')
            }

            if (touchendY === touchstartY) {
                result.push('tap')
            }
            callBack(result)
        }
    },
}

export default helper
